import { render, staticRenderFns } from "./areaLockBase.vue?vue&type=template&id=256cc976&scoped=true&"
import script from "./areaLockBase.vue?vue&type=script&lang=js&"
export * from "./areaLockBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256cc976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256cc976')) {
      api.createRecord('256cc976', component.options)
    } else {
      api.reload('256cc976', component.options)
    }
    module.hot.accept("./areaLockBase.vue?vue&type=template&id=256cc976&scoped=true&", function () {
      api.rerender('256cc976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberAreaLock/areaLockBase.vue"
export default component.exports